// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"PaginationWrapper_paginationWrapper__86sWx"};